import * as t from 'ts-codec';
import { ObjectId, Resource } from '@journeyapps-labs/micro-codecs';
import { PaginatedResponse } from './pagination.js';
import { ResourceType } from '../types/types-resources.js';
export var ReportReason;
(function (ReportReason) {
    ReportReason["SPAM"] = "spam";
    ReportReason["HARASSMENT"] = "harassment";
    ReportReason["HATEFUL_CONTENT"] = "hateful_content";
    ReportReason["IMPERSONATION"] = "impersonation";
    ReportReason["INAPPROPRIATE_CONTENT"] = "inappropriate_content";
    ReportReason["UNDERAGE_CONTENT"] = "underage_content";
    ReportReason["OTHER"] = "other";
})(ReportReason || (ReportReason = {}));
export var ReportStatus;
(function (ReportStatus) {
    ReportStatus["OPEN"] = "open";
    ReportStatus["REVIEWED"] = "reviewed";
    ReportStatus["DISMISSED"] = "dismissed";
    ReportStatus["ACTIONED"] = "actioned";
})(ReportStatus || (ReportStatus = {}));
export var ModerationState;
(function (ModerationState) {
    ModerationState["NONE"] = "none";
    ModerationState["UNDER_REVIEW"] = "under_review";
    ModerationState["ACTIONED"] = "actioned";
})(ModerationState || (ModerationState = {}));
export var ApiModerationRoutes;
(function (ApiModerationRoutes) {
    ApiModerationRoutes["REPORT"] = "/api/v1/moderation/report";
    ApiModerationRoutes["LIST_REPORTED_ENTITIES"] = "/api/v1/trusted/moderation/reported-entities";
    ApiModerationRoutes["LIST_ENTITY_REPORTS"] = "/api/v1/trusted/moderation/entity-reports";
})(ApiModerationRoutes || (ApiModerationRoutes = {}));
export var ApiValidationCodes;
(function (ApiValidationCodes) {
    ApiValidationCodes["REPORT_ALREADY_EXISTS"] = "REPORT_ALREADY_EXISTS";
})(ApiValidationCodes || (ApiValidationCodes = {}));
export const CreateReportRequest = t.object({
    target_type: t.Enum(ResourceType),
    target_id: ObjectId,
    reason: t.Enum(ReportReason),
    message: t.string.optional()
});
export const ReportedEntityResource = Resource.and(t.object({
    target_type: t.Enum(ResourceType),
    target_id: ObjectId,
    total_report_count: t.number,
    open_report_count: t.number,
    last_reported_at: t.any,
    moderation_state: t.Enum(ModerationState)
}));
export const ReportedEntitiesResponse = PaginatedResponse(ReportedEntityResource);
export const GetEntityReportsRequest = t.object({
    target_type: t.Enum(ResourceType),
    target_id: ObjectId
});
export const ModerationReportResource = Resource.and(t.object({
    target_type: t.Enum(ResourceType),
    target_id: ObjectId,
    reason: t.Enum(ReportReason),
    message: t.string.optional(),
    status: t.Enum(ReportStatus)
}));
export const EntityReportsResponse = t.array(ModerationReportResource);
